import MasterTargeting from "./MasterTargeting";

export default MasterTargeting;
